"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  place-items: center;\n  height: 100%;\n"], ["\n  display: grid;\n  place-items: center;\n  height: 100%;\n"])));
var templateObject_1;
//# sourceMappingURL=root.js.map